import bitrixApi from "./bitrixApi";


const moduleName = "evraz:lk.api.sites"
const moduleNameBpm = "evraz:lk.api.serviceforbpm"
function createResponse(status:string, data:any){
    return {
        isSuccess: status=="success",
        data: data
    }
}
const getcities = async ():Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getcities','get',{});
    const customResponse =  createResponse(response.status, response?.data?.data)
    return customResponse
}
const getconstants = async ():Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getconstants','get',{});
    const data = response?.data?.data?.find((x: { pageName: string; })=>x.pageName="calcBuildingCard")
    const customResponse =  createResponse(response.status, data?.calcBuildingCard)
    return customResponse
}
const getrelations = async ():Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getconstants','get',{});
    const data = response?.data?.data?.filter((x: { hasOwnProperty: (arg0: string) => any; })=>x.hasOwnProperty('dependencies'))
    const customResponse =  createResponse(response.status, data)
    return customResponse
}

const getLinks = async ():Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getconstants','get',{});
    const data = response?.data?.data?.filter((x: { hasOwnProperty: (arg0: string) => any; })=>x.hasOwnProperty('cartCardPath'))
    const customResponse =  createResponse(response.status, data)
    return customResponse
}

const getarticle = async (params = {}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getarticles','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
    //var a = 1;
}
const gettemplate = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'gettemplates','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const getTemplateByParam = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getTemplateByParam','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const getVerifiedUser = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getUserIdByJWT','post',params);
    const data = response?.data?.user;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const getUnverifiedUser = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getUserIdByBxCookie','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const getbasket = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'getBasketsByParams','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const createBasket = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'createBasket','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const addBasketItem = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'addBasketItem','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const updateBasket = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'updateBasket','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const removeBasketItem = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'deleteBasketItem','post',params);
    const data = response.data.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const getJWTByUserId = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleNameBpm,'getJwtByUserId','post',params);
    const data = response.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
const addFormLog = async (params={}):Promise<any> => {
    const response:any = await bitrixApi(moduleName,'createLogsForm','post',params);
    const data = response?.data?.data;
    const customResponse =  createResponse(response.status, data)
    return customResponse
}
export function getData(){ 

    return {
        getcities,
        getconstants,
        getarticle,
        gettemplate,
        getrelations,
        getbasket,
        getLinks,
        getUnverifiedUser,
        getVerifiedUser,
        createBasket,
        addBasketItem,
        removeBasketItem,
        updateBasket,
        getJWTByUserId,
        getTemplateByParam,
        addFormLog
    }
}